
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { useAppBase } from '@/core/composables/AppBase';
import { IOrigem } from '@/models/Entidades/IOrigem';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import ServicoOrigem from '@/servicos/ServicoOrigem';
import { IResposta } from '@/core/models/IResposta';

export default defineComponent({
  name: 'OrigemCadastro',
  components: {
    ComunicacaoApi,
  },
  setup() {
    const {
      appBase, apresentarComunicacaoApi, apresentarRespostaRedirecionamento, obterCodigoRota,
    } = useAppBase();
    const servicoOrigem = new ServicoOrigem();

    const state = reactive({
      origem: {} as IOrigem,
    });

    async function obterorigem(codigo:number) {
      appBase.carregando = true;
      state.origem = await servicoOrigem.obter(codigo);
      appBase.carregando = false;
    }

    function limparDados() {
      state.origem = {} as IOrigem;
      state.origem.codigo = 0;
      state.origem.status = true;
    }

    onBeforeMount(async () => {
      limparDados();
      const codigoorigem = obterCodigoRota();
      if (codigoorigem > 0) {
        await obterorigem(codigoorigem);
      }
    });

    async function salvar() {
      appBase.resposta = {} as IResposta;
      apresentarComunicacaoApi('Aguarde por favor... Estamos salvando as informações da origem.');
      if (state.origem.codigo === 0) {
        appBase.resposta = await servicoOrigem.incluir(state.origem);
      } else {
        appBase.resposta = await servicoOrigem.atualizar(state.origem);
      }

      apresentarRespostaRedirecionamento('Origens');
    }
    return {
      appBase,
      state,
      salvar,
    };
  },
});
